/* Quarry — rotating announcement messages.
   Only engages with 2+ messages. Pauses on hover and on keyboard focus, and
   with reduced-motion it simply shows the first message and never cycles. */
(function () {
  var wrap = document.getElementById('shopify-section-announcement-bar');
  if (!wrap) return;
  var bars = wrap.querySelectorAll('.announcement-bar');
  if (bars.length < 2) return;

  wrap.classList.add('qannounce');
  var i = 0, timer = null;
  var DELAY = parseInt(wrap.dataset.rotate || '5000', 10);
  bars[0].classList.add('is-active');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function step() {
    bars[i].classList.remove('is-active');
    i = (i + 1) % bars.length;
    bars[i].classList.add('is-active');
  }
  function start() { stop(); timer = setInterval(step, DELAY); }
  function stop() { if (timer) clearInterval(timer); timer = null; }

  wrap.addEventListener('mouseenter', stop);
  wrap.addEventListener('mouseleave', start);
  wrap.addEventListener('focusin', stop);
  wrap.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', function () {
    document.hidden ? stop() : start();
  });
  start();
})();

/* Header condense. Observes the announcement bar -- an element that already
   exists -- rather than injecting a sentinel, which is what broke the previous
   attempt. Once it scrolls out of view the header tightens. */
(function () {
  var head = document.getElementById('shopify-section-header');
  if (!head || !('IntersectionObserver' in window)) return;
  var watch = document.getElementById('shopify-section-announcement-bar')
           || document.querySelector('main');
  if (!watch) return;
  new IntersectionObserver(function (entries) {
    head.classList.toggle('q-condensed', !entries[0].isIntersecting);
  }, { threshold: 0 }).observe(watch);
})();
